import { arrayOf, string } from "prop-types";
import { useSelector } from "react-redux";

import { useDataCachedAttributes } from "web/hooks/useDataCached";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

const CityWithProvince = ({ city, province, className }) => {
  const { token, id: storeId } = useSelector((state) => state.app.storeConfig);

  const { loading, error, data } = useDataCachedAttributes({
    ids: ["location_province"],
    storeId,
    token,
  });

  switch (true) {
    case !!loading && (!data || !Object.keys(data).length): {
      return (
        <div className={className} data-t1="city_with_province">
          {city}
        </div>
      );
    }
    case !!error: {
      console.error(error);
      return (
        <div className={className} data-t1="city_with_province">
          {city}
        </div>
      );
    }
    default: {
      const currentOption =
        isArrayHasItems(data) &&
        data[0] &&
        isArrayHasItems(data[0].attribute_options) &&
        data[0].attribute_options.find(
          (option) => `${option.value}` === `${province}`
        );
      const provinceLabel =
        currentOption && currentOption.label
          ? `, w. ${currentOption.label}`
          : "";

      return (
        <div className={className} data-t1="city_with_province">
          {city}
          {provinceLabel}
        </div>
      );
    }
  }
};

CityWithProvince.propTypes = {
  className: string,
  city: string.isRequired,
  province: arrayOf(string).isRequired,
};

CityWithProvince.defaultProps = {
  className: "",
};

export default CityWithProvince;
